import React, { useEffect, useRef, useState } from "react";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { toast } from "react-toastify";

const Adduserpopup = ({ setOpen, setIsLoading }) => {
  const { decryptData } = useEncryption();

  const [validationErrors, setValidationErrors] = useState({});

  const [userFields, setUserFields] = useState({
    name: "",
    email: "",
    phone: "",
    employeRole: "",
    password: "",
    conformpassword: "",
  });

  const onChangeInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setUserFields({
      ...userFields,
      [name]: value,
    });

    const errors = validateField(name, value);
    setValidationErrors({
      ...validationErrors,
      [name]: errors[name],
    });
  };
  const validateField = (name, value) => {
    const errors = {};

    // Validation logic for each input field
    switch (name) {
      case "name":
        if (!value) {
          errors[name] = "Name is required";
        } else {
          errors[name] = "";
        }
        break;
      case "employeRole":
        if (!value) {
          errors[name] = "Employee Role is required";
        } else {
          errors[name] = "";
        }
        break;
      case "email":
        if (!value) {
          errors[name] = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(value)) {
          errors[name] = "Invalid email format";
        } else {
          errors[name] = "";
        }
        break;
      case "phone":
        if (!value) {
          errors[name] = "Phone is required";
        } else if (!/^\d{10}$/.test(value)) {
          errors[name] = "Phone must be 10 digits";
        }

        break;
      case "password":
        if (!value) {
          errors[name] = "Password is required";
        }

        break;
      // case "conformpassword":
      //   if (userFields.password !== userFields.conformpassword) {
      //     errors[name] = "Passwords do not match";
      //   }
      //   break;
      case "conformpassword":
        if (!value) {
          errors[name] = "Confirm Password is required";
        } else if (userFields.password !== value) {
          errors[name] = "Passwords do not match";
        } else {
          errors[name] = "";
        }
        break;
      default:
        errors[name] = "";
    }

    return errors;
  };
  const mydata = {
    name: userFields?.name,
    email: userFields?.email,
    phone: userFields?.phone,
    employeRole: userFields?.employeRole,
    password: userFields?.password,
    conformpassword: userFields?.conformpassword,
  };

  const handleSubmit = async () => {
    // Validation logic
    const errors = {};

    if (!userFields.name) {
      errors.name = "Name is required";
    }

    if (!userFields.email) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(userFields.email)) {
      errors.email = "Invalid email format";
    }
    if (!userFields.employeRole) {
      errors.employeRole = " employeRole is required";
    }

    if (!userFields.phone) {
      errors.phone = "Phone is required";
    } else if (!/^\d{10}$/.test(userFields.phone)) {
      errors.phone = "Phone must be 10 digits";
    }

    if (!userFields.password) {
      errors.password = "Password is required";
    }

    // If there are validation errors, set them in the state and don't make the API call
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // If no validation errors, proceed with the API call
    await axiosInstanceAuth
      .post("signup_user", mydata)
      .then((res) => {
        const myData = decryptData(res.data.data);
        console.log("User Data ===---===>>>", myData);
        console.log("=========myData", myData);
        if (myData.status) {
          setUserFields({
            name: "",
            email: "",
            phone: "",
            employeRole: "",
            password: "",
            conformpassword: "",
          });
          setOpen(false);
          toast.success(myData.message);
          setIsLoading(true);
        } else {
          toast.error(myData.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const handleOpen = () => setOpen(false);

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    // Attach the event listener when the component mounts.
    document.addEventListener("mousedown", handleClickOutside);

    // Remove the event listener when the component unmounts to prevent memory leaks.
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpen]);

  return (
    <>
      <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center">
        <div
          className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 "
          ref={modalRef}
        >
          <div>
            <div>
              <div className=" border-[1.5px] border-[#000000] m-10 rounded-[20px] p-">
                <div className="flex justify-center items-center">
                  <div className="absolute">
                    <button class="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                      Add User
                    </button>
                  </div>
                </div>
                <div className="p-5">
                  <div class="grid grid-cols-1 gap-6 mt-4 lg:grid-cols-2">
                    <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Full Name<span className="text-red-500">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        class="block w-full px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                        name="name"
                        value={userFields?.name}
                        onChange={onChangeInput}
                      />
                      {validationErrors.name && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.name}
                        </p>
                      )}
                    </div>

                    {/* <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Employee Role<span className="text-red-500">*</span>{" "}
                      </label>

                      <select
                        class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                        name="employeRole"
                        value={userFields?.employeRole}
                        onChange={onChangeInput}
                      >
                        <option value="" disabled>
                          Choose a any
                        </option>
                        <option value="Supervisior">Supervisior</option>
                        <option value="Team Leader">Team Leader</option>
                        <option value="Project Manager">Project Manager</option>
                        <option value="Chief Engineer">Chief Engineer</option>
                        <option value="Other">Other</option>
                      </select>
                      {validationErrors.employeRole && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.employeRole}
                        </p>
                      )}
                    </div> */}

                    <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Employee Role<span className="text-red-500">*</span>{" "}
                      </label>

                      <input
                        type="text"
                        class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                        name="employeRole"
                        value={userFields?.employeRole}
                        onChange={onChangeInput}
                      />
                      {validationErrors.employeRole && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.employeRole}
                        </p>
                      )}
                    </div>

                    <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Email<span className="text-red-500">*</span>{" "}
                      </label>
                      <input
                        type="email"
                        class="block w-full px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                        name="email"
                        value={userFields?.email}
                        onChange={onChangeInput}
                      />
                      {validationErrors.email && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.email}
                        </p>
                      )}
                    </div>

                    <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Password<span className="text-red-500">*</span>{" "}
                      </label>
                      <input
                        type="password"
                        class="block w-full px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                        name="password"
                        value={userFields?.password}
                        onChange={onChangeInput}
                      />
                      {validationErrors.password && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.password}
                        </p>
                      )}
                    </div>

                    <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Phone<span className="text-red-500">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        class="block w-80 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                        name="phone"
                        value={userFields?.phone}
                        onChange={onChangeInput}
                      />
                      {validationErrors.phone && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.phone}
                        </p>
                      )}
                    </div>

                    {/* <div className="relative">
                            <label
                              class="text-[#000000] font-sans font-semibold text-lg"
                              for="username"
                            >
                              Phone<span className="text-red-500">*</span>{" "}
                              <span className="text-[#929292]">(Required)</span>
                            </label>
                            <PhoneInput
                                country={"in"}
                              // name="phone_number"
                              inputStyle={{
                                border: "none",
                              }}
                              className="block w-full  px- py-1 pl-[1px] mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="phone"
                              value={userFields?.phone}
                              onChange={onChangeInput}
                            />
                          </div> */}

                    <div>
                      <label
                        class="text-[#000000] font-sans font-semibold text-lg"
                        for="username"
                      >
                        Confirm Password
                        <span className="text-red-500">*</span>{" "}
                      </label>
                      <input
                        id="username"
                        type="password"
                        placeholder=""
                        class="block w-full px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                        name="conformpassword"
                        value={userFields?.conformpassword}
                        onChange={onChangeInput}
                      />
                      {validationErrors.conformpassword && (
                        <p className="text-red-500 text-xs pt-1">
                          {validationErrors.conformpassword}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="flex justify-center mt-10 gap-4 mb-5">
                  <div>
                    <button
                      onClick={() => {
                        handleSubmit();

                        // toggleForm();
                      }}
                      // onClick={toggleForm}
                      class="bg-[#5DC90A] px-6 py-2 leading-5  text-white font-bold  rounded-[10px]"
                    >
                      Save
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={handleOpen}
                      class="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[10px]"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Adduserpopup;
